<template>
  <div>
    <strong>Adresse</strong>
    <br />
    <div v-if="adresseExiste">
      {{ client.adresse1 }}
      <br v-if="client.adresse2 != ''" />
      {{ client.adresse2 }}
      <br v-if="client.adresse2" />
      {{ client.codePostal }} {{ client.ville }}
    </div>
    <div v-else>Non renseignée</div>

    <div class="mt-3" v-if="client.email != ''">
      <strong>E-mail</strong>
      <br />
      {{ client.email ? client.email : "Non renseigné" }}
    </div>

    <div class="mt-3" v-if="client.telephoneFixe || client.telephonePortable">
      <v-row>
        <v-col cols="6" v-if="client.telephoneFixe"
          ><strong>Téléphone fixe</strong>
          <br />
          {{ client.telephoneFixe }}</v-col
        >
        <v-col cols="6" v-if="client.telephonePortable"
          ><strong>Téléphone portable</strong>
          <br />
          {{ +client.telephonePortable }}</v-col
        >
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    client: Object,
  },
  computed: {
    adresseExiste() {
      if (this.client.adresse1 || this.client.codePostal || this.client.ville) {
        return true;
      }
      return false;
    },
  },
};
</script>
